
























































import Vue from "vue";
import Component from "vue-class-component";
import Coordinates from "coordinate-parser";
import {
  IMobilePlatformUpdate,
  IMobilePlatformCreate,
  IMobilePlatformsTable,
} from "@/store/features/models";
import { features, user } from "@/store";

const AddFeatureFormProps = Vue.extend({
  props: {
    platform: {
      type: (Object as () => IMobilePlatformUpdate) || null,
    },
    activate: {
      type: Boolean,
      default: false,
    },
  },
});

@Component<AddFeatureForm>({
  watch: {
    platform: function(newValue:IMobilePlatformsTable| null) {
      if (newValue) {
        this.fillForm(newValue);
        this.update = true;
      } else {
        this.update = false;
      }
    },
    dialog: function(newValue) {
      if (!newValue) {
        this.clearForm();
        this.$emit("finished");
      }
    },
    activate: function(newValue) {
      if (newValue && !this.dialog) {
        this.dialog = true;
      }
    },
  },
})
export default class AddFeatureForm extends AddFeatureFormProps {
  dialog: boolean = false;
  valid: boolean = true;
  snackbar: boolean = false;
  timeout: number = 3000;
  nombre: string = "";
  nameRules: any[] = [
    (v: string) => !!v || "Se requiere un nombre",
    (v: string) =>
      (v && v.length <= 30) || "El nombre debe de ser menor de 20 caracteres",
  ];
  coordenadas: string = "";
  coordRules: any[] = [(v: string) => !!v || "Las coordenadas son requeridas"];
  validCoords: boolean = false;
  errorCoords: boolean = false;
  sendError: boolean = false;
  update: boolean = false;

  fillForm(platform: IMobilePlatformsTable) {
    this.nombre = platform.nombre || "";
    this.coordenadas = platform.coordenadas || "";
  }
  clearForm() {
    this.nombre = "";
    this.coordenadas = "";
    this.valid = true;
    (this.$refs.form as any).resetValidation();
  }
  send() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      let parsedCoords = this.coordValidate();
      if (this.validCoords && parsedCoords != null) {
        const data: IMobilePlatformCreate = {
          nombre: this.nombre,
          geometry: `POINT (${parsedCoords.lon} ${parsedCoords.lat})`,
          created_by: user.getters.userId,
        };
        if (this.update) {
          const newPlatform: IMobilePlatformUpdate = {
            ...data,
            id: this.platform.id,
          };
          features
            .dispatch("updateMobilePlatform", newPlatform)
            .then(() => (this.snackbar = true))
            .catch(() => (this.sendError = true));
          this.$emit("created");
          this.dialog = false;
        } else {
          features
            .dispatch("createMobilePlatform", data)
            .then(() => (this.snackbar = true))
            .catch(() => (this.sendError = true));
          this.$emit("created");
          this.dialog = false;
        }
      }
    }
  }
  coordValidate() {
    try {
      let coords = new Coordinates(this.coordenadas);
      let lat = coords.getLatitude();
      let lon = coords.getLongitude();
      this.validCoords = true;
      this.errorCoords = false;
      return { lat, lon };
    } catch (error) {
      this.validCoords = false;
      this.errorCoords = true;
      return null;
    }
  }
}
